import PropTypes from 'prop-types'
import { useState } from 'react'

import { PanelSection } from 'components/attacks/details/AttackStyles'
import Execution from 'components/attacks/details/Execution'
import ExecutionPanelHeader from 'components/attacks/details/ExecutionPanelHeader'
import KubernetesExecution from 'components/attacks/details/kubernetes/KubernetesExecution'

export default function ExecutionPanel({ attackId, executions, kubernetes }) {
  const [shouldShowAll, setShouldShowAll] = useState(false)

  return (
    <PanelSection>
      <ExecutionPanelHeader
        executions={executions}
        kubernetes={kubernetes}
        openExecutionWithInsights={() =>
          !shouldShowAll && setShouldShowAll(true)
        }
      />
      {kubernetes
        ? executions.map(({ target, executions: targetExecutions }) => (
            <KubernetesExecution
              key={target.uid}
              attackId={attackId}
              resetViewAll={() => shouldShowAll && setShouldShowAll(false)}
              target={target}
              targetExecutions={targetExecutions}
              viewAll={shouldShowAll}
            />
          ))
        : executions.map((execution) => (
            <Execution
              key={execution.guid}
              attackId={attackId}
              execution={execution}
              resetViewAll={() => shouldShowAll && setShouldShowAll(false)}
              viewAll={shouldShowAll}
            />
          ))}
    </PanelSection>
  )
}

ExecutionPanel.propTypes = {
  attackId: PropTypes.string,
  executions: PropTypes.array,
  kubernetes: PropTypes.bool
}
